module.exports = function (fox) {
	'use strict';

	var getSkinComponent = require('../../../utils/get-skin-component');
	
	getSkinComponent('splash')(fox);

	var require__widgets = require.context('./widget', false, /\.js$/);
	var widgetsFiles = require__widgets.keys();

	widgetsFiles.forEach(function (file) {
		require__widgets(file)(fox);
	});

	require('./stylus/_splash.styl');
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/splash/index.js
// module id = 485
// module chunks = 4